import { useEffect, useState } from 'react';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';

import { useDynamicConfig } from ':support/providers/DynamicConfigProvider';

function useIsMobile() {
  const { isPhone, isPhoneLandscape } = useBreakpoints();
  const [isMobile, setIsMobile] = useState(false);
  const { showMobile } = useDynamicConfig();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(showMobile && (isPhone || isPhoneLandscape || window.innerWidth <= 768)); // Adjust the breakpoint as needed
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [showMobile, isPhone, isPhoneLandscape]);

  return isMobile;
}

export default useIsMobile;
